export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/navLeft.268d0652.svg","height":24,"width":14,"blurWidth":0,"blurHeight":0};